import script from "./Profile-Management.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile-Management.vue?vue&type=script&setup=true&lang=js"

import "./Profile-Management.vue?vue&type=style&index=0&id=05574182&scoped=true&lang=css"

import exportComponent from "/Users/Joe/Documents/Projects/MCR-WebFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05574182"]])

export default __exports__